import * as React from "react";
import { Navigate, useLocation } from "react-router";

/**
 * A retired route that moved (MV2-848, app/Main). Old deep links keep
 * working: `/admin/catalogs/register-maps?x=1` → `/admin/developer/register-maps?x=1`.
 * Client-side 301 — replace, so Back does not bounce.
 */
export function MovedRoute({
  from,
  to,
}: {
  from: string;
  to: string;
}): React.ReactElement {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.startsWith(from) ? pathname.slice(from.length) : "";
  return <Navigate to={`${to}${rest}${search}${hash}`} replace />;
}
